import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP7PoorRoasOvw202603: FaireAdPerformancePeriodEntity = {
  token: "perf_p7_poor_roas_ovw_202603",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2026-03-01",
  endDate: "2026-03-31",
  impressions: 928,
  clicks: 17,
  adsSpendDollars: 61,
  budgetDollars: 600,
  salesDollars: 139,
  bestEstimateRoas: 2.28,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.1,
  newCustomersAcquired: 1,
  reorderConversions: 0,
  dataAvailableAtDate: "2026-04-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
